export default {
  computed: {
    dictList() {
      return this.$store.state.dict.list
    }
  },
  methods: {
    getDictConstantValue(source, type, text, page) {
      
      let dict_result = null

      if(source == 'epod_do_master' && page == 'emptote'){
        
        if (text == 'N'){
          dict_result = 'Loaded'
        }
      }

      if(source == 'epod_do_master' && page == 'storereturn'){
        
        if (text == 'N'){
          dict_result = 'Created'
        }
      }

      if(source == 'epod_do_detail' && page == 'dolist'){
        
        if (text == 'N'){
          dict_result = 'Pending'
        }
        else if (text == 'C'){
          dict_result = 'Shorted'
        }
        else if(text == 'A' || text == 'R'){
          dict_result = 'Received'
        }
      }

      if(source == 'epod_do_detail' && page == 'recaudit'){
        
        if (text == 'N'){
          dict_result = 'Pending'
        }
        else if(text == 'S'){
          dict_result = 'Shorted'
        }
        else if(text == 'A'){
          dict_result = 'Audited'
        }
      }

      if (dict_result == null){
        if (!type || !text) {
          return '--'
        }
        let result = _.filter(this.dictList, obj => {
          return (
            obj.source === source &&
            (obj.lookupType || '').toUpperCase() === type.toUpperCase() &&
            obj.text === text
          )
        })
        if (!result || !result.length) {
          return text
        }
        return (result[0] || {}).description || text
      }
      else{
        return dict_result
      }
    },
    getDictValue(source, type, text) {
      if (!type || !text) {
        return '--'
      }
      let result = _.filter(this.dictList, obj => {
        return (
          obj.source === source &&
          (obj.lookupType || '').toUpperCase() === type.toUpperCase() &&
          obj.text === text
        )
      })
      if (!result || !result.length) {
        return text
      }
      return (result[0] || {}).description || text
    },
    queryAllDict() {
      this.$store.dispatch({ type: 'dict/getAllForDict' })
    }
  }
}
